// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEnrollmentReportErrorDetailsDto
 */
export interface IEnrollmentReportErrorDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentReportErrorDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentReportErrorDetailsDto
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentReportErrorDetailsDto
     */
    error_code?: string;
}

/**
 * Check if a given object implements the IEnrollmentReportErrorDetailsDto interface.
 */
export function instanceOfIEnrollmentReportErrorDetailsDto(value: object): value is IEnrollmentReportErrorDetailsDto {
    return true;
}

export function IEnrollmentReportErrorDetailsDtoFromJSON(json: any): IEnrollmentReportErrorDetailsDto {
    return IEnrollmentReportErrorDetailsDtoFromJSONTyped(json, false);
}

export function IEnrollmentReportErrorDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEnrollmentReportErrorDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'message': json['message'] == null ? undefined : json['message'],
        'error_code': json['errorCode'] == null ? undefined : json['errorCode'],
    };
}

export function IEnrollmentReportErrorDetailsDtoToJSON(json: any): IEnrollmentReportErrorDetailsDto {
    return IEnrollmentReportErrorDetailsDtoToJSONTyped(json, false);
}

export function IEnrollmentReportErrorDetailsDtoToJSONTyped(value?: IEnrollmentReportErrorDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'message': value['message'],
        'errorCode': value['error_code'],
    };
}

